/* SuperHoodie redesign – basket page: AJAX quantity changes and add-ons, then reload.
   Links keep working without JavaScript (they point at /cart/change). */
(function () {
  var root = document.querySelector('[data-sh-cart]');
  if (!root) return;

  var routes = window.routes || {};
  var changeUrl = (routes.cart_change_url || '/cart/change') + '.js';
  var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
  var errorBox = root.querySelector('[data-sh-cart-error]');

  function showError(message) {
    root.classList.remove('is-busy');
    if (!errorBox) return;
    errorBox.textContent = message || 'Something went wrong. Please try again.';
    errorBox.hidden = false;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
        }
        return data;
      });
    });
  }

  function run(request) {
    if (root.classList.contains('is-busy')) return;
    root.classList.add('is-busy');
    if (errorBox) errorBox.hidden = true;
    request.then(function () {
      window.location.reload();
    }).catch(function (error) {
      showError(error.message);
    });
  }

  root.addEventListener('click', function (event) {
    var change = event.target.closest('[data-sh-change]');
    if (change) {
      event.preventDefault();
      var quantity = Math.max(0, parseInt(change.getAttribute('data-qty'), 10) || 0);
      run(post(changeUrl, { line: parseInt(change.getAttribute('data-line'), 10), quantity: quantity }));
      return;
    }

    var addon = event.target.closest('[data-sh-addon]');
    if (addon) {
      event.preventDefault();
      addon.setAttribute('aria-busy', 'true');
      run(post(addUrl, { items: [{ id: parseInt(addon.getAttribute('data-sh-addon'), 10), quantity: 1 }] }));
    }
  });
})();
